module.exports = __webpack_public_path__ + "img/konsultacija.8a612a97.svg";